import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Newsletter } from './pages/Newsletter';
import { GetStarted } from './pages/GetStarted';
import { useRoute } from './lib/navigation';
export function App() {
  const route = useRoute();
  useEffect(() => {
    document.title = 'Arrive Psychotherapy | Online Therapy for Young Adults';
  }, []);
  const renderPage = () => {
    switch (route) {
      case '#/':
      case '':
        return <Home data-id="element-0" />;
      case '#/about':
        return <About data-id="element-1" />;
      case '#/services':
        return <Services data-id="element-2" />;
      case '#/newsletter':
        return <Newsletter data-id="element-3" />;
      case '#/get-started':
        return <GetStarted data-id="element-4" />;
      default:
        return <Home data-id="element-5" />;
    }
  };
  return <div className="min-h-screen bg-white selection:bg-terracotta/30 selection:text-teal flex flex-col" data-id="element-6">
      <Navbar data-id="element-7" />
      <main className="flex-grow" data-id="element-8">{renderPage()}</main>
      <Footer data-id="element-9" />
    </div>;
}